import styled from 'styled-components';

import { Text } from '@catalyze/ui';

export const StyledText = styled(Text)`
    text-align: center;
    margin-top: 0.5rem;
    color: ${({ theme }) => theme.colors.formLabel};
    font-size: ${({ theme }) => theme.fontSizes[4]};
`;
